"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TotalRolloverAmountResponseToJSON = exports.TotalRolloverAmountResponseFromJSONTyped = exports.TotalRolloverAmountResponseFromJSON = exports.instanceOfTotalRolloverAmountResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the TotalRolloverAmountResponse interface.
 */
function instanceOfTotalRolloverAmountResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfTotalRolloverAmountResponse = instanceOfTotalRolloverAmountResponse;
function TotalRolloverAmountResponseFromJSON(json) {
    return TotalRolloverAmountResponseFromJSONTyped(json, false);
}
exports.TotalRolloverAmountResponseFromJSON = TotalRolloverAmountResponseFromJSON;
function TotalRolloverAmountResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adAccountId': !(0, runtime_1.exists)(json, 'ad_account_id') ? undefined : json['ad_account_id'],
        'totalRolloverAmountMicro': !(0, runtime_1.exists)(json, 'total_rollover_amount_micro') ? undefined : json['total_rollover_amount_micro'],
    };
}
exports.TotalRolloverAmountResponseFromJSONTyped = TotalRolloverAmountResponseFromJSONTyped;
function TotalRolloverAmountResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ad_account_id': value.adAccountId,
        'total_rollover_amount_micro': value.totalRolloverAmountMicro,
    };
}
exports.TotalRolloverAmountResponseToJSON = TotalRolloverAmountResponseToJSON;
